var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruckSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 193,
    viewBox: "0 0 89 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 193,
    width: 142,
    height: 47,
    transform: "rotate(-90 17 193)",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_423_2299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 51V29C20 22.9249 24.9249 18 31 18H50C56.0751 18 61 22.9249 61 29V51H20Z",
    fill: "#FEFDFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 54,
    width: 3,
    height: 8,
    transform: "rotate(-90 37 54)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 35V34C18 32.8954 18.8954 32 20 32V35H18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 35V32C62.1046 32 63 32.8954 63 34V35H61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 35C23 35 23.2536 28.8792 25.5362 28.4712C27.8188 28.0631 54.7029 27.6551 55.971 28.4712C57.2391 29.2873 58 35 58 35H23Z",
    fill: "url(#paint0_linear_423_2299)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_423_2299",
    x: 0,
    y: 0,
    width: 89,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_423_2299"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_423_2299",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_423_2299",
    x1: 40.5,
    y1: 28,
    x2: 40.5,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757575"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckSvg);
export default __webpack_public_path__ + "static/media/TruckSVG.30af0ed927ce09b62b54e2f1ebf38705.svg";
export { ForwardRef as ReactComponent };